<template>
  <div
    id="contents"
    class="search contents"
  >
    <navigation-tab :tabs="tabs"></navigation-tab>
    <router-view></router-view>
  </div>
</template>

<script>
import NavigationTab from '@/views/base/NavigationTab'

import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  components: {
    NavigationTab
  },
  mixins: [mixin],
  watch: {
    bottom: {
      handler(n, o) {
        if (n && this.isProductTab) {
          this.handleAPICall()
        }
      }
    },
    '$route.params.query': function(n, o) {
      // query가 변경 되면 검색을 다시한다.
      this.searchBoth({ searchText: n })
    }
  },
  data() {
    return {
      bottom: false
    }
  },
  computed: {
    ...mapGetters('search', ['product', 'productList', 'tag', 'tagList']),
    isProductTab() {
      return this.$route.name === 'search-product'
    },
    query() {
      return decodeURIComponent(this.$route.params.query)
    },
    tabs() {
      return [
        {
          name: `상품 (${this.product.totalCount})`,
          url: `/search/product/${this.query}` // 상세에서 뒤로가기 했을 경우 안되서 query로 변경
        },
        {
          name: `태그 (${this.tag.totalCount})`,
          url: `/search/tag/${this.query}`
        }
      ]
    }
  },
  methods: {
    ...mapActions('search', [
      'openSearchForm',
      'closeSearchForm',
      'setHeaderFix',
      'searchProduct',
      'searchBoth'
    ]),

    handleScroll() {
      if (this.isProductTab) {
        const { last } = this.product
        if (last === false) {
          this.bottom = this.bottomVisible()
        }
      }
    },
    handleAPICall(reset) {
      if (this.isProductTab && this.product.page > 0) {
        this.searchProduct({ searchText: this.$route.params.query, reset })
      }
    }
  },
  mounted() {
    this.openSearchForm()
    this.setHeaderFix(true)
    window.addEventListener('scroll', this.handleScroll)
    this.searchBoth({ searchText: this.query })
  },
  destroyed() {
    this.closeSearchForm()
    this.setHeaderFix(false)
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
</style>
